module.exports = __webpack_public_path__ + "img/addimage.e3be2a9d.png";